import { browserFastApiClient, requireFastApiAccessToken } from "@/core/fastapi";
import { getTargetsApiCrud, type GetTargetsRequest } from "@/generated/fastapi";

export async function getTargets(
  accessToken: string | null | undefined,
  request: GetTargetsRequest = {},
) {
  const response = await getTargetsApiCrud({
    client: browserFastApiClient,
    auth: requireFastApiAccessToken(accessToken),
    body: request,
  });

  if (response.status !== 200) {
    throw new Error(`Failed to retrieve targets (${response.status})`);
  }

  return response.data ?? [];
}
